module.exports = __webpack_public_path__ + "static/media/rubber-trees.08a2411d.png";